export default "__VITE_ASSET__CKyTFj4E__"